import { makeURL } from "@nauverse/make-url"
import type { PlanData } from "./types"

export const AVAILABLE_PLANS: Array<PlanData> = [
  {
    id: "solo",
    displayName: "signUp.plans.solo.displayName",
    description: "signUp.plans.solo.description",
    additionalInfo: "signUp.plans.solo.additionalInfo",
    continueButtonText: "signUp.plans.solo.continueButton",
    continueButtonLink: makeURL(`${process.env.NEXT_PUBLIC_BASE_SIGNUP_URL}`, "launcher-app/signup/editaccount", {
      params: {
        trialType: "solo",
      },
    }),
  },
  {
    id: "team",
    displayName: "signUp.plans.team.displayName",
    description: "signUp.plans.team.description",
    qualification: "signUp.plans.team.qualification",
    qualificationList: ["signUp.plans.team.qualificationList.0", "signUp.plans.team.qualificationList.1", "signUp.plans.team.qualificationList.2", "signUp.plans.team.qualificationList.3"],
    continueButtonText: "signUp.plans.team.continueButton",
    continueButtonLink: makeURL(`${process.env.NEXT_PUBLIC_BASE_SIGNUP_URL}`, "launcher-app/signup/editaccount", {
      params: {
        trialType: "team",
      },
    }),
  },
]

export const VALID_PLANS = AVAILABLE_PLANS.map((plan) => plan.id)
